import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';

import AdminForm from './AdminForm';

import AdminsApi from 'Api/CRM/Modules/AdminsApi';
import Admin from 'Api/Models/Admin';
import Card from 'crm/elements/common/Card';
import handleValidationErrors, { ValidationErrors } from 'crm/helpers/ResponseErrorHelper';

function AdminCreate() {
    const [errors, setErrors] = useState<ValidationErrors>({});
    const history = useHistory();

    const handleCreateAdmin = async (newAdmin: Admin) => {
        try {
            await AdminsApi.storeModel(newAdmin);
            history.push('/admins');
        } catch (error) {
            handleValidationErrors(error, setErrors);
        }
    };

    return (
        <Card title="Create new admin">
            <AdminForm action={handleCreateAdmin} errors={errors} />
        </Card>
    );
}

export default AdminCreate;
